module.exports = __webpack_public_path__ + "fecbef38b4553137685054e037b95c0e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/dive-tank.png
// module id = 2013
// module chunks = 0